// CHA-621 — which workflow definition a finding may be sent to, decided by the finding's rule.
//
// Platform and tenant-agnostic: the caller passes its tenant's definitions ({ id, rule }). A finding
// can be sent only when EXACTLY ONE definition binds its rule. No definition means no Send; two or
// more is ambiguous, and with no picker the only safe answer is also no Send (fail closed). The
// server's start_run rule lock (CHA-596) stays the authority; this only decides what the UI offers.
export default function definitionForRule(definitions, rule) {
  if (typeof rule !== 'string' || rule === '' || !Array.isArray(definitions)) return null;
  const bound = definitions.filter((d) => d && typeof d.id === 'string' && d.rule === rule);
  return bound.length === 1 ? bound[0].id : null;
}
